var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app',[(_vm.saved)?_c('div',[_c('form-saved-success',{attrs:{"dis":false,"idParams":_vm.$route.params.id}})],1):_c('FormViewRun2',{attrs:{"edit":true,"formSavedId":_vm.$route.params.id},on:{"saveClick":_vm.updateReturnFunc}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }